<era-active-device-syncs-progress-bar-ui [maximumActiveDeviceSyncs]="maximumActiveDeviceSyncs"
                                         [currentActiveDeviceSyncs]="currentActiveDeviceSyncs()"></era-active-device-syncs-progress-bar-ui>